export const APP_NAME = 'Comfast Cloud Wifi';
export const APP_LOGO_SRC = '/logo.png';
